// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3SgEE","actionsCol":"EnrolledClinics_actionsCol__36ZLP"};